import React from "react";

const GROUPS = [
  { label: "Frontend", items: ["React", "Next.js", "Vue", "Bootstrap 5"] },
  { label: "Backend", items: ["Node.js", "Java / Spring", ".NET", "Python"] },
  { label: "Data & Integration", items: ["REST / GraphQL", "Kafka", "ETL pipelines", "SQL / NoSQL"] },
  { label: "Cloud & DevOps", items: ["AWS", "Azure", "Docker", "Kubernetes", "CI/CD"] },
];

export default function TechStack() {
  return (
    <section id="stack" className="section">
      <div className="container">
        <div className="eyebrow mb-3">Technology</div>
        <h2 className="display-font mb-5" style={{ fontSize: "2.2rem", fontWeight: 600, color: "var(--navy-deep)" }}>
          We build with what fits, not what's trending
        </h2>
        <div className="row g-4">
          {GROUPS.map((g) => (
            <div className="col-md-6 col-lg-3" key={g.label}>
              <div className="mono-label mb-3" style={{ color: "var(--teal)" }}>{g.label}</div>
              <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
                {g.items.map((item) => (
                  <li key={item} style={{ color: "var(--navy-deep)", fontWeight: 500, fontSize: "0.95rem" }}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
